import type { GridOptions } from '../../../components/ui/table';
import { commonGridOptions } from '../../../lib/agGridOptions';
import {
  GRID_PAGE_SIZE,
  GRID_PAGE_SIZE_SELECTOR,
} from '../../../components/shared/agGridCells';
import {
  TRANSACTION_GRID_VIEWPORT_OFFSET_REM,
  computeGridHeightRem,
} from '../../../lib/gridLayout';
import type { TransactionOrderRow } from '../models/types';

export { GRID_PAGE_SIZE, GRID_PAGE_SIZE_SELECTOR };

/** Fills remaining viewport below the TM hero / filters (scales with page height). */
export const TRANSACTION_GRID_HEIGHT = computeGridHeightRem(
  TRANSACTION_GRID_VIEWPORT_OFFSET_REM,
);

export const transactionGridOptions = {
  ...commonGridOptions,
  suppressRowClickSelection: true,
  tooltipShowDelay: 300,
  tooltipShowMode: 'standard',
  tooltipInteraction: true,
  overlayNoRowsTemplate:
    '<span class="text-sm text-muted-foreground">No transactions match the current filters.</span>',
} satisfies GridOptions<TransactionOrderRow>;
